import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SPIN_EVENT } from '../utils/spinBreakdown';

const fmt = (n) => `$${Math.abs(Number(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Shows "-$5.00 bet / +$7.20 win = +$2.20" for ~3s after each slot spin.
export const SpinBreakdownToast = () => {
    const [spin, setSpin] = useState(null);
    const timer = useRef(null);

    useEffect(() => {
        const show = (d) => {
            const bet = Number(d?.bet) || 0, win = Number(d?.win) || 0;
            if (!(bet > 0 || win > 0)) return;
            clearTimeout(timer.current);
            setSpin({ bet, win, key: Date.now() });
            timer.current = setTimeout(() => setSpin(null), 3000);
        };
        const onEvent = (e) => show(e.detail);
        const onMessage = (e) => {
            if (e.origin === window.location.origin && e.data?.type === 'slot:spin-result') show(e.data);
        };
        window.addEventListener(SPIN_EVENT, onEvent);
        window.addEventListener('message', onMessage);
        return () => {
            clearTimeout(timer.current);
            window.removeEventListener(SPIN_EVENT, onEvent);
            window.removeEventListener('message', onMessage);
        };
    }, []);

    const net = spin ? Math.round((spin.win - spin.bet) * 100) / 100 : 0;
    return (
        <AnimatePresence>
            {spin && (
                <motion.div
                    key={spin.key}
                    data-testid="spin-breakdown-toast"
                    initial={{ opacity: 0, y: -12 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -12 }}
                    transition={{ duration: 0.2 }}
                    className="fixed inset-x-0 mx-auto w-fit z-[9999] pointer-events-none whitespace-nowrap flex items-center gap-2 rounded-full border border-white/15 bg-black/80 px-4 py-1.5 text-xs sm:text-sm font-semibold text-white shadow-lg backdrop-blur-md"
                    style={{ top: 'calc(env(safe-area-inset-top, 0px) + 22vh)' }}
                >
                    {spin.bet > 0 && <span data-testid="spin-breakdown-bet" className="text-red-300">-{fmt(spin.bet)} bet</span>}
                    {spin.bet > 0 && <span className="text-white/40">/</span>}
                    <span data-testid="spin-breakdown-win" className="text-emerald-300">+{fmt(spin.win)} win</span>
                    <span className="text-white/40">=</span>
                    <span data-testid="spin-breakdown-net" className={net >= 0 ? 'text-emerald-300' : 'text-red-300'}>
                        {net >= 0 ? '+' : '-'}{fmt(net)}
                    </span>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default SpinBreakdownToast;
